import React, { useEffect, useState } from "react";

import "./editModal.css";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import EditIcon from "../../../assets/icon/Edit.svg";

import CloseIcon from "@mui/icons-material/Close";
import { getTeams, profileImageUpload } from "../../../services/MainApiDetails";
import { ERROR } from "../../../utilities/colors";
import Select from "react-select";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditTeamModal = (prop) => {
  const [favTeam, setFavTeam] = useState(null);

  const [open, setOpen] = useState(false);
  const [teams, setTeams] = useState(false);
  const [error, setError] = useState(false);
  const [options, setOptions] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  useEffect(() => {
    getTeamCountries();
  }, []);

  React.useEffect(() => {
    if (!!prop.team)
      setFavTeam({ value: prop.team._id.$oid, label: prop.team.team_name });
    if(open) setError("")
  }, [prop.team, open]);

  const buttonDisabled = React.useMemo(
    () => prop.team?._id?.$oid === favTeam?.value,
    [prop.team?._id?.$oid === favTeam?.value],
  );

  function getTeamCountries() {
    getTeams({})
      .then((res) => {
        if (res.data.status === 1 && !!res?.data?.data?.length) {
          const teamList = !!res?.data?.data?.length
            ? res?.data?.data?.map((team) => ({
                value: team?._id,
                label: team?.team_name,
              }))
            : [];
          setOptions(teamList);
        }
      })
      .catch((err, message) => {
        console.log(err + message);
      });
  }

  const handleClose = () => {
    setOpen(false);
  };
  function updateTeam() {
    if (!favTeam.value) {
      setError("Please Choose Team");
    } else {
      profileImageUpload({
        team_id: favTeam.value,
      })
        .then((res) => {
          if (res.data.status) {
            alert("Team updated successfully");
            setOpen(false);
            window.location.reload();
          } else {
            alert(res.data.message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  return (
    <div className="editNameModal">
      <div onClick={handleClickOpen} className="userInfo-edit">
        <img src={EditIcon} alt="" />
      </div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="editNameModal-wrapper">
          <div className="editNameModal-closeIcon">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="editNameModal-header">
            <h2>Edit Your Team</h2>
          </div>
          <div className="editNameModal-form-wrapper">
            <div className="editNameModal-input-wrapper">
              <div className="editNameModal-inputBox">
                <span>Your favorite team:</span>
                <Select
                  options={options}
                  value={favTeam}
                  defaultMenuIsOpen={false}
blurInputOnSelect={true}
                  onChange={(e) => {
                    setFavTeam(e)}}
                  placeholder="Choose your favourite team"
                  className="select-option"
                  menuPlacement="auto"
                  menuPosition="fixed"
                  menuPortalTarget={null} // ✅ Renders inside modal instead of body
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      position: "absolute", // ✅ Let it flow inside dialog
                      zIndex: 9999, // ensure visibility
                      width: "100%",
                    }),
                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: "200px", // adjust as you like
                      overflowY: "auto",
                    }),
                  }}
                />

                <span style={{ color: ERROR }}>{error}</span>
              </div>
            </div>
          </div>

          <div className="editNameModal-button-wrapper">
            <Button
              type="button"
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? "editNameModal-login-btn-disabled"
                  : "editNameModal-login-btn"
              }
              onClick={updateTeam}
            >
              {!!prop.team ? "UPDATE" : "CONFIRM"}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default EditTeamModal;
